// @generated by protoc-gen-connect-web v0.6.0 with parameter "target=ts,ts_nocheck=false"
// @generated from file api/scribe/svc_document_template.proto (package com.diagnocat.scribe, syntax proto3)
/* eslint-disable */

import { CloneDocumentTemplateReq, CloneDocumentTemplateResp, CreateDocumentTemplateReq, CreateDocumentTemplateResp, DeleteDocumentTemplateReq, DeleteDocumentTemplateResp, GetCommunityDocumentTemplateReq, GetCommunityDocumentTemplateResp, GetDocumentTemplateBySeriesIDReq, GetDocumentTemplateBySeriesIDResp, GetDocumentTemplateReq, GetDocumentTemplateResp, ImportCommunityDocumentTemplateReq, ImportCommunityDocumentTemplateResp, ListDocumentTemplatesReq, ListDocumentTemplatesResp, ListDocumentTemplateVersionsReq, ListDocumentTemplateVersionsResp, PublishCommunityDocumentTemplateReq, PublishCommunityDocumentTemplateResp, RestoreDocumentTemplateReq, RestoreDocumentTemplateResp, UnpublishCommunityDocumentTemplateReq, UnpublishCommunityDocumentTemplateResp, UpdateDocumentTemplateDraftReq, UpdateDocumentTemplateDraftResp } from "./svc_document_template_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service com.diagnocat.scribe.DocumentTemplateService
 */
export const DocumentTemplateService = {
  typeName: "com.diagnocat.scribe.DocumentTemplateService",
  methods: {
    /**
     * @generated from rpc com.diagnocat.scribe.DocumentTemplateService.Get
     */
    get: {
      name: "Get",
      I: GetDocumentTemplateReq,
      O: GetDocumentTemplateResp,
      kind: MethodKind.Unary,
    },
    /**
     * Resolves the current version of a template series.
     *
     * @generated from rpc com.diagnocat.scribe.DocumentTemplateService.GetBySeriesID
     */
    getBySeriesID: {
      name: "GetBySeriesID",
      I: GetDocumentTemplateBySeriesIDReq,
      O: GetDocumentTemplateBySeriesIDResp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.diagnocat.scribe.DocumentTemplateService.List
     */
    list: {
      name: "List",
      I: ListDocumentTemplatesReq,
      O: ListDocumentTemplatesResp,
      kind: MethodKind.Unary,
    },
    /**
     * Every version of a series, newest first.
     *
     * @generated from rpc com.diagnocat.scribe.DocumentTemplateService.ListVersions
     */
    listVersions: {
      name: "ListVersions",
      I: ListDocumentTemplateVersionsReq,
      O: ListDocumentTemplateVersionsResp,
      kind: MethodKind.Unary,
    },
    /**
     * Templates are versioned rather than edited in place: pass BaseSeriesID to
     * add a version to an existing series, omit it to start a new one.
     *
     * @generated from rpc com.diagnocat.scribe.DocumentTemplateService.Create
     */
    create: {
      name: "Create",
      I: CreateDocumentTemplateReq,
      O: CreateDocumentTemplateResp,
      kind: MethodKind.Unary,
    },
    /**
     * Rewrites a draft in place, keeping its ID, series and version number.
     * Only a draft can be rewritten; any other status is rejected. Create adds
     * a new version to the series.
     *
     * @generated from rpc com.diagnocat.scribe.DocumentTemplateService.UpdateDraft
     */
    updateDraft: {
      name: "UpdateDraft",
      I: UpdateDocumentTemplateDraftReq,
      O: UpdateDocumentTemplateDraftResp,
      kind: MethodKind.Unary,
    },
    /**
     * Soft-delete, reversed by Restore. System-owned templates are protected.
     *
     * @generated from rpc com.diagnocat.scribe.DocumentTemplateService.Delete
     */
    delete: {
      name: "Delete",
      I: DeleteDocumentTemplateReq,
      O: DeleteDocumentTemplateResp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.diagnocat.scribe.DocumentTemplateService.Restore
     */
    restore: {
      name: "Restore",
      I: RestoreDocumentTemplateReq,
      O: RestoreDocumentTemplateResp,
      kind: MethodKind.Unary,
    },
    /**
     * Copies community or official assets into the caller's organization.
     *
     * @generated from rpc com.diagnocat.scribe.DocumentTemplateService.Clone
     */
    clone: {
      name: "Clone",
      I: CloneDocumentTemplateReq,
      O: CloneDocumentTemplateResp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.diagnocat.scribe.DocumentTemplateService.GetCommunity
     */
    getCommunity: {
      name: "GetCommunity",
      I: GetCommunityDocumentTemplateReq,
      O: GetCommunityDocumentTemplateResp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.diagnocat.scribe.DocumentTemplateService.ImportCommunity
     */
    importCommunity: {
      name: "ImportCommunity",
      I: ImportCommunityDocumentTemplateReq,
      O: ImportCommunityDocumentTemplateResp,
      kind: MethodKind.Unary,
    },
    /**
     * Publishing is idempotent and re-writes the listing; withdrawing keeps the
     * stored listing so a later publish can restore it.
     *
     * @generated from rpc com.diagnocat.scribe.DocumentTemplateService.PublishCommunity
     */
    publishCommunity: {
      name: "PublishCommunity",
      I: PublishCommunityDocumentTemplateReq,
      O: PublishCommunityDocumentTemplateResp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.diagnocat.scribe.DocumentTemplateService.UnpublishCommunity
     */
    unpublishCommunity: {
      name: "UnpublishCommunity",
      I: UnpublishCommunityDocumentTemplateReq,
      O: UnpublishCommunityDocumentTemplateResp,
      kind: MethodKind.Unary,
    },
  }
} as const;

